/*
 * @Author: zhaozhenda
 * @Date: 2024-08-14 16:57:45
 * @LastEditTime: 2024-08-28 17:26:25
 * @LastEditors: zhaozhenda
 * @Description:
 */
export const SAFE_TIME = 300;

// 产品（活动）id
// eslint-disable-next-line no-magic-numbers
export const SENCE_ID = process.env.VUE_APP_CURRENTMODE === 'release' ? 238 : 263;
// 登录id
// eslint-disable-next-line no-magic-numbers
export const LOGIN_ID = process.env.VUE_APP_CURRENTMODE === 'release' ? 709 : 717;
// 任务id
// eslint-disable-next-line no-magic-numbers
export const MISSION_ID = process.env.VUE_APP_CURRENTMODE === 'release' ? 710 : 715;

export const APP_ID = 547;
// 任务key值
export const USER_ACTION = 'share';
export const USER_LOGIN = 'enter';

// 积分类型
export const POINT_TYPE = 'kaihu_edu';
